import React, {Component, Fragment} from "react";
import * as PropTypes from "prop-types";
import PostCreatedTime from "../../posts/postDetails/postMetaData/PostCreatedTime";


export class PublishedResponseStatus extends Component {

  static propTypes = {
    item: PropTypes.any.isRequired,
    className: PropTypes.any,
    extendedStatusOnly: PropTypes.bool
  };

  static defaultProps = {
    extendedStatusOnly: false
  };

  render() {
    const {item, className, extendedStatusOnly} = this.props;
    const color = item.completeTime ? "text-success" : item.failure && item.failure.attemptsRemaining === 0 ? "text-danger" : "text-muted";
    let status;
    if(!item.requiresApproval){
      status = <Fragment>
        {
          item.completeTime ?
            <span className={`${color} ss ss-check`} /> :
            item.failure && item.failure.attemptsRemaining === 0 ?
              <span className={`${color} far fa-times`} /> :
              <span className={`${color} far fa-calendar-alt`} />
        }

        {extendedStatusOnly &&
          <span className={color} style={{marginLeft: '5px'}}>{
            item.completeTime ?
              "Success" :
              item.failure && item.failure.attemptsRemaining === 0 ?
                "Failed To Post" :
                "Pending"
          }</span>
        }

        { !extendedStatusOnly && <PostCreatedTime date={item.scheduledTime} style={{marginLeft: '5px'}} />}
      </Fragment>
    }

    return (
      <div className={!!className ? className : ''}>
        { status }
      </div>
    );
  }
}
